export default __webpack_public_path__ + "img/dvOMiNIB.4ac437a5.svg";